/* oxlint-disable */
'use client';

import { Suspense, useEffect, useState } from 'react';

import { getActiveTournaments } from '@/app/actions/tournaments';

import { TournamentGridSkeleton, TournamentHeroSkeleton } from '@/features/tournaments/lobby/loading-skeleton';
import TournamentFilters from '@/features/tournaments/lobby/tournament-filters';
import TournamentGrid from '@/features/tournaments/lobby/tournament-grid';
import { TournamentHeroCarousel } from '@/features/tournaments/lobby/tournament-hero';

import { TournamentStatus } from '@/features/tournaments/utils/interfaces';
import { userUIStore } from '@/stores/userUIStore';
import { getCurrencySymbol } from '@/utils/currency';

import { useAuth } from '@/core/auth/client/AuthProvider';
import { HomeLogicWrapperPublic } from '@/features/v2/shared/Wrappers';
import { ComingSoonPage } from '@/components/common/ComingSoonPage';

export default function TorneosPage() {
  const { session } = useAuth();
  const { isSidebarOpen } = userUIStore();
  const [tournaments, setTournaments] = useState<any[]>([]);
  const [activeStatus, setActiveStatus] = useState('active');
  const [activeSport, setActiveSport] = useState('all');
  const userId = session?.user?.id ? session.user.id : undefined;
  const userCurrency = session?.user?.currency || 'USD';

  useEffect(() => {
    async function fetchTournaments() {
      const data = await getActiveTournaments();
      console.log(data);
      setTournaments(
        data.map((t: any) => {
          // Determine status based on dates
          const now = new Date();
          const start = new Date(t.startDate);
          const end = new Date(t.endDate);
          let status: TournamentStatus = TournamentStatus.upcoming;
          if (now < start) status = TournamentStatus.upcoming;
          else if (now >= start && now <= end) status = TournamentStatus.active;
          else if (now > end) status = TournamentStatus.finished;

          // Calculate total prize pool (sum if array, parse if string with commas)
          let totalPrizePool = 0;
          if (Array.isArray(t.prizePool)) {
            totalPrizePool = t.prizePool.reduce((sum: number, prize: any) => { return sum + Number(prize); }, 0);
          } else if (typeof t.prizePool === 'string') {
            // If it's a string with commas, split and sum
            totalPrizePool = t.prizePool.split(',').reduce((sum: number, prize: string) => { return sum + Number(prize.trim()); }, 0);
          } else {
            totalPrizePool = Number(t.prizePool) || 0;
          }

          return {
            id: t.id,
            name: t.name,
            description: t.description,
            prizePool: `${getCurrencySymbol(userCurrency)} ${totalPrizePool.toLocaleString()}`,
            participants: t.participantCount,
            timeLeft: '',
            status,
            backgroundImage: t.backgroundImage,
            sport: t.sportType,
            isRegistered: userId ? t.isRegistered : false,
            isLoggedIn: !!userId,
            startDate: t.startDate,
            endDate: t.endDate,
            feature: t.feature || false,
            terms: t.terms,
          };
        }),
      );
    }
    fetchTournaments();
  }, [userId]);

  // Filter tournaments by status and sport
  const filteredTournaments = tournaments.filter((t) => {
    const statusMatch = t.status === activeStatus;
    const sportMatch = activeSport === 'all' || t.sport === activeSport;
    return statusMatch && sportMatch;
  });

  // Filter featured tournaments for hero carousel
  const featuredTournaments = tournaments.filter((t) => { return t.feature === true; });

  return (
    <>
      <HomeLogicWrapperPublic />
      {/* <div className="control-padding">
        <div
          className={` w-full pt-14 max-md:pl-0 max-lg:pt-12 space-y-12`}
        >
          <div className="min-h-screen bg-linear-to-b from-slate-900 via-indigo-950 to-slate-900">
            
            {tournaments.length === 0 ? (
              <TournamentHeroSkeleton />
            ) : (
              <TournamentHeroCarousel tournament={featuredTournaments.length > 0 ? featuredTournaments : [tournaments[0]]} />
            )}
            
            <div className="px-4 pb-6">
              <TournamentFilters
                tournaments={tournaments}
                activeStatus={activeStatus}
                setActiveStatus={setActiveStatus}
                activeSport={activeSport}
                setActiveSport={setActiveSport}
              />
              <Suspense fallback={<TournamentGridSkeleton />}>
                <TournamentGrid tournaments={filteredTournaments} />
              </Suspense>
            </div>
          </div>
        </div>
      </div> */}
      <ComingSoonPage title="Torneos" />
    </>
  );
}
